export default "__VITE_ASSET__CEWdWdyY__"